import columns from '../../../../react-table/helpers/columns';

export const diffConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    const { row } = rowInfo;
    if (row) {
      className = 'text-grey';
      if (row.diff < 0) {
        className = 'text-red';
      } else {
        className = 'text-green';
      }
    }
  }
  return {
    className,
  };
};

export const otherColumnsConditionalProps = col => (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    const { row } = rowInfo;
    if (row) {
      className = 'text-grey';
      if (row[col] < 90) {
        className = 'text-red';
      } else {
        className = 'text-green';
      }
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn,
    NumberColumn,
  } = columns(data);

  const firstColumn = String.raw`Ctry from\Ctry to`;

  return [
    {
      Header: '',
      columns: [
        new TextColumn(`${firstColumn}`, 'ctryFrom'),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('At', 'at').withGetProps(otherColumnsConditionalProps('at')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Be', 'be').withGetProps(otherColumnsConditionalProps('be')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Ca', 'ca').withGetProps(otherColumnsConditionalProps('ca')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Ch', 'ch').withGetProps(otherColumnsConditionalProps('ch')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('De', 'de').withGetProps(otherColumnsConditionalProps('de')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Dk', 'dk').withGetProps(otherColumnsConditionalProps('dk')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Es', 'es').withGetProps(otherColumnsConditionalProps('es')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Fi', 'fi').withGetProps(otherColumnsConditionalProps('fi')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Fr', 'fr').withGetProps(otherColumnsConditionalProps('fr')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Gb', 'gb').withGetProps(otherColumnsConditionalProps('gb')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Gr', 'gr').withGetProps(otherColumnsConditionalProps('gr')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Hu', 'hu').withGetProps(otherColumnsConditionalProps('hu')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Ie', 'ie').withGetProps(otherColumnsConditionalProps('ie')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Is', 'is').withGetProps(otherColumnsConditionalProps('is')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('It', 'it').withGetProps(otherColumnsConditionalProps('it')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Lu', 'lu').withGetProps(otherColumnsConditionalProps('lu')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Nl', 'nl').withGetProps(otherColumnsConditionalProps('nl')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('No', 'no').withGetProps(otherColumnsConditionalProps('no')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Pl', 'pl').withGetProps(otherColumnsConditionalProps('pl')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Pt', 'pt').withGetProps(otherColumnsConditionalProps('pt')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Se', 'se').withGetProps(otherColumnsConditionalProps('se')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Us', 'us').withGetProps(otherColumnsConditionalProps('us')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Total', 'ctryP1').withGetProps(otherColumnsConditionalProps('ctryP1')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Prev', 'ctryP2').withGetProps(otherColumnsConditionalProps('ctryP2')),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Diff', 'diff').withGetProps(diffConditionalProps),
      ],
    },
  ];
};
